import { createReducer } from '@reduxjs/toolkit';

import { OrbitManager, Loadable } from 'models';
import { makeThunkFromAPICall } from 'state';

export type OrbitsState = {
    list: Loadable<OrbitManager.Orbit[]>;
};

const initialState: OrbitsState = {
    list: { status: 'idle' },
};

export const [getOrbit, setOrbit] = makeThunkFromAPICall(
    OrbitManager.getOrbitById,
    'Orbits/get',
);

export const [getOrbitCZML, setOrbitCZML] = makeThunkFromAPICall(
    OrbitManager.getOrbitCZML,
    'Orbits/czml',
);

export const [getOrbitList, setOrbitList] = makeThunkFromAPICall(
    OrbitManager.listOrbits,
    'Orbits/list',
);

export const orbitsReducer = createReducer(initialState, (builder) => {
    builder.addCase(setOrbitList, (state, action) => {
        return {
            ...state,
            list: { ...state.list, ...action.payload.loadable },
        };
    });
});

export const orbitsActions = {
    getOrbitList,
    setOrbitList,
    getOrbit,
    getOrbitCZML,
};

export default orbitsReducer;
